import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs: string[];
  @Input() expandBreadcrumb = false;

  constructor(public router: Router, public activatedRoute: ActivatedRoute) {
    this.getRoute();
  }

  ngOnInit(): void {
    this.getRoute();
  }


  public getRoute() {
    this.breadcrumbs = this.router.url.split('/');
  }
}
